/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { memo } from "react";

// 非活性アイコン
const smallDisable = require("assets/img/link/ico-arrowBack-disable.png");
const mediumDisable = require("assets/img/link/ico-arrowBack-disabled@2x.png");
const largeDisable = require("assets/img/link/ico-arrowBack-disabled@3x.png");

// 活性アイコン
const smallActive = require("assets/img/link/ico-arrowBack-active.png");
const mediumActive = require("assets/img/link/ico-arrowBack-active@2x.png");
const largeActive = require("assets/img/link/ico-arrowBack-active@3x.png");

/**
 * 【前の1週間】ボタン
 * @param {Number} page 表示ページ
 * @param {function} fn ボタン押下時の挙動
 */
const PrevButton = memo(({ page, fn }) => {

  return (
    <button
      type="button"
      css={page === 0 ? btnInactive : btnActive}
      disabled={page === 0}
      onClick={fn}
    >
      {/** 表示ページでアイコン切り分け */}
      {page === 0 ?
        <img
          css={arrowBackImg}
          src={smallDisable}
          srcSet={`${smallDisable} 1x, ${mediumDisable} 2x, ${largeDisable} 3x`}
          alt="前の1週間"
        />
        :
        <img
          css={arrowBackImg}
          src={smallActive}
          srcSet={`${smallActive} 1x, ${mediumActive} 2x, ${largeActive} 3x`}
          alt="前の1週間"
        />
      }
      <span css={page === 0 ? btnTextInactive : btnTextActive}>前の1週間</span>
    </button>
  );
});

export default PrevButton;

const mtgCaption = css`
  font-size: var(--mtg-caption-s);
  font-weight: var(--mtg-caption-w);
`;

const calenderBtn = css`
  width: 110px;
  height: 40px;
  border: 1px solid var(--mtg-urbanblue);
  border-radius: 4px;
  background-color: var(--mtg-white);
  display: inline-block;
  vertical-align: middle;

  :hover:not(:disabled) {
    background-color: var(--mtg-blue-4);
  }
`;

const btnActive = css`
  ${calenderBtn}
  background-color: var(--mtg-white);
`;

const btnInactive = css`
  ${calenderBtn}
  background-color: var(--mtg-grey-3);
  border: 0px;
`;

const btnTextActive = css`
  ${mtgCaption}
  line-height: 40px;
  margin-right: 12px;
  color: var(--mtg-urbanblue);
`;

const btnTextInactive = css`
  ${mtgCaption}
  line-height: 40px;
  margin-right: 12px;
  color: var(--mtg-grey-1);
`;

const arrowBackImg = css`
  float: left;
  width: 40px;
  height: 40px;
`;
